import { MouseEventHandler } from 'react';
import { getAreaComponents, getMagnoliaHost } from "@/utilities/functions/magnoliaUtils";
import { openLink } from "@/utilities/functions";
import { useEffect, useState } from "react";
import { Carousel } from "br2s-ui-componentlibrary_r2_02";
import { SystemIcon } from '../../foundation/assets/system-icon';

interface Slide {
    /**
     * Id of the card
     */
    id: string;
    /**
     * content of the card
     */
    content: string | React.JSX.Element;
    /**
     * content of the image card
     */
    card?: CardProps;
}

export interface ButtonProps {
    /**
     * id of the button?
     */
    id: string;
    /**
     * What type of button is this?
     */
    type?: 'primary' | 'secondary' | 'tertiary' | 'quiet';
    /**
     * How large should the button be?
     */
    size?: 'medium' | 'large';
    /**
     * Should the button take up the full width of the screen? Block button
     */
    isBlock?: boolean;
    /**
     * Class name of the icon
     */
    iconClassName?: SystemIcon;
    /**
     * Option where to display the icon on the button
     */
    iconType?: 'no-icon' | 'prepended' | 'appended';
    /**
     * Is this a Icon Button?
     */
    isIconButton?: boolean;
    /**
     * Is button Disabled?
     */
    isDisabled?: boolean;
    /**
     * Button label
     */
    label?: string;
    /**
     * Aria label of button. Should be used when the button only display icon for accessibility
     */
    ariaLabel?: string;
    /**
     * Click handler
     */
    onClick?: MouseEventHandler<HTMLButtonElement>;
    /**
     * WARNING: This props should not be used directly. Please use DropdownButton component
     */
    isDropdownButton?: boolean;
    /**
     * WARNING: This props should not be used directly. Please use DropdownButton component
     */
    isDropdownButtonExpanded?: boolean;
    /**
     * Limit label to 24 characters. (Optional: defaults to true)
     */
    limitLabel?: boolean;
  }

interface CardProps {
    /**
     * ID of component
     */
    id: string;
    /**
     * layout of card
     */
    layout?: 'horizontal' | 'vertical' | 'vertical stacked';
    /**
     * Metadata values
     */
    metadata?: string[];
    /**
     * Image source
     */
    imgSrc?: string;
    /**
     * Image alt text
     */
    imgAlt?: string;
    /**
     * Card title
     */
    title: string;
    /**
     * Card description
     */
    description?: string;
    /**
     * Array of props for action buttons. Array should only have 2 elements max
     */
    actionButtons?: readonly [prop?: ButtonProps, prop?: ButtonProps];
}

function CarouselAdapter(props: any) {
    const initialSlideState: Slide[] = [];
    const [slides, setSlides] = useState(initialSlideState);

    useEffect(() => {
        if (props.hide || !props.cards) return;

        const slides: Slide[] = [];

        const mgnlHost = getMagnoliaHost();

        const cards = getAreaComponents(props.cards);

        cards.forEach((element: any, index: number) => {
            const slide: Slide = {
                id: `slide-${index}`,
                content: element.content,
                card: {
                    id: `slide-card-${index}`,
                    layout: element.layout,
                    metadata: element.metadata,
                    imgSrc: element.image ? `${mgnlHost}${element.image['@link']}` : undefined,
                    imgAlt: element.imageAlt,
                    title: element.title,
                    description: element.description,
                    actionButtons: element.addBtn ? [
                        {
                            id: `slide-card-${index}-btn`,
                            label: element.btnLabel,
                            type: element.btnType,
                            onClick: () => element.btnNavUrl ? openLink(element.btnNavUrl) : {},
                            iconType: element.btnIconType,
                            iconClassName: element.btnIconClassName
                        }
                    ] : [],
                }
            }
            slides.push(slide);
        });

        setSlides(slides);
    }, []);
    
    return (
        (!props.hide && slides.length > 0 && 
            <Carousel
                id={props.id}
                type={props.type}
                title={props.title}
                centeredSlides={props.centeredSlides}
                cardsPerSlide={props.cardsPerSlide}
                maxSlide={props.maxSlide}
                slides={slides}
                link={props.link}
                darkMode={props.darkMode}
                withMargin={props.withMargin}
                maxHeight={props.maxHeight}
                effect={props.effect}
                style={{}}
            />
            )
    );
}

export default CarouselAdapter;
